/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CreateReceiptDto } from '../../models/create-receipt-dto';
import { ReceiptDto } from '../../models/receipt-dto';

export interface ReceiptControllerUpdate$Params {
  id: string;
  enrollmentScheduleId: string;
      body: CreateReceiptDto
}

export function receiptControllerUpdate(http: HttpClient, rootUrl: string, params: ReceiptControllerUpdate$Params, context?: HttpContext): Observable<StrictHttpResponse<ReceiptDto>> {
  const rb = new RequestBuilder(rootUrl, receiptControllerUpdate.PATH, 'patch');
  if (params) {
    rb.path('id', params.id, {});
    rb.query('enrollmentScheduleId', params.enrollmentScheduleId, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ReceiptDto>;
    })
  );
}

receiptControllerUpdate.PATH = '/api/receipt/{id}';
